import { Component, OnInit } from '@angular/core';
import {Program} from '@models/program';
import {User} from '@models/user';
import * as moment from '@node_modules/moment';
import {CurriculumService} from '@services/curriculum/curriculum.service';
import {MatDialog} from '@node_modules/@angular/material';
import {Lesson} from '@models/lesson';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';

@Component({
  selector: 'app-view-month-curriculum',
  templateUrl: './view-month-curriculum.component.html',
  styleUrls: ['./view-month-curriculum.component.scss']
})
export class ViewMonthCurriculumComponent implements OnInit {
  attendances;
  progressLineWidth;
  withProgressLine = false;
  largeModal = false;
  lessonsIds = [];
  user: User;
  programs: Program[];
  viewCirriculumDialog;
  constructor(
    private curriculumService: CurriculumService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    // console.log(this.largeModal);
    this.attendances.map(att => {
      if (!this.lessonsIds.includes(att.lesson_id)) {
        this.lessonsIds.push(att.lesson_id);
      }
      const date = moment(att.created_at, 'YYYY-MM-DD hh:mm:ss');
      if (date.isValid()) {
        att['date'] = date.format('ll');
        att['time'] = date.format('hh:mm:ss');
      }
      this.programs.map( pr => {
        if (pr.id === att.program_id * 1) {
          att['programName'] = pr.program_name;
        }
      });
    });
    if (this.lessonsIds.length > 0) {
      this.curriculumService.getAll(null, 'lesson', this.lessonsIds).subscribe(
        (resp: {data: any}) => {
          this.attendances.map( att => {
            if (resp.data[att.lesson_id] && resp.data[att.lesson_id].length > 0) {
              att['lessonName'] = resp.data[att.lesson_id][0].name;
            }
          });
          // console.log(resp, this.attendances);
        }
      );
    }
  }
  onOpenViewCurriculumModal(attendance) {
    let currentLesson;
    attendance.allCurriculumLessons.map(lesson => {
      if (lesson.id === attendance.lesson_id) {
        currentLesson = lesson;
      }
    });
    ViewCurriculumComponent.source = 'student';
    ViewCurriculumComponent.onlyLesson = true;
    ViewCurriculumComponent.initLesson = currentLesson;
    ViewCurriculumComponent.fullContent = false;
    ViewCurriculumComponent.onlyDescription = true;
    this.viewCirriculumDialog = this.dialog.open(ViewCurriculumComponent);
    ViewCurriculumComponent.modalRef = this.viewCirriculumDialog;
    this.viewCirriculumDialog.afterClosed().subscribe(result => {
      this.viewCirriculumDialog.close();
    });
  }
  close() {
    this.dialog.closeAll();
  }
}
